module.exports = __webpack_public_path__ + "img/justice.ad63be7b.svg";